"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var utils_1 = require("./../utils");
var kendo_react_intl_1 = require("@progress/kendo-react-intl");
var kendo_react_data_tools_1 = require("@progress/kendo-react-data-tools");
var constants_1 = require("../constants");
var kendo_react_common_1 = require("@progress/kendo-react-common");
exports.GridCell = function (props) {
    var _a;
    var defaultRendering = null;
    var intl = kendo_react_intl_1.useInternationalization();
    var navigationAttributes = kendo_react_data_tools_1.useTableKeyboardNavigation(props.id);
    if (props.rowType === 'groupFooter') {
        defaultRendering = React.createElement("td", { className: props.className });
    }
    else if (props.field !== undefined && props.rowType !== 'groupHeader') {
        var data = utils_1.getNestedValue(props.field, props.dataItem);
        var dataAsString = '';
        if (data !== undefined && data !== null) {
            dataAsString = props.format ?
                intl.format(props.format, data) :
                data.toString();
        }
        var className = kendo_react_common_1.classNames(props.className, { 'k-state-selected': props.isSelected });
        defaultRendering = (React.createElement("td", __assign({ colSpan: props.colSpan, style: props.style, className: className, role: 'gridcell', "aria-colindex": props.ariaColumnIndex, "aria-selected": props.isSelected }, (_a = {}, _a[constants_1.GRID_COL_INDEX_ATTRIBUTE] = props.columnIndex, _a), navigationAttributes), dataAsString));
    }
    return props.render ?
        props.render.call(undefined, defaultRendering, props) :
        defaultRendering;
};
//# sourceMappingURL=GridCell.js.map